//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'detail-fold-mask',
  data: function data() {
    return {
      showMore: false,
      hasMore: false,
      performanceId: 0
    };
  },
  props: {
    id: String,
    foldStatus: Boolean,
    showNewPage: Boolean,
    isDetail: Boolean
  },
  mounted: function mounted() {
    var performanceId = this.$route.params.performanceId;
    this.performanceId = performanceId;
    this.setHasMore();
    if (this.foldStatus && this.isDetail) {
      if (this.isDetail) {
        window.seedAction({
          evt: 'view',
          bid: 'b_movie_9rec7wnu_mv',
          cid: 'c_c21utqjf',
          abtest: this.showNewPage ? 1 : 0,
          custom: {
            performance_id: this.performanceId
          }
        });
      }
    }
  },
  methods: {
    toggleFoldMask: function toggleFoldMask() {
      this.showMore = !this.showMore;
      if (this.isDetail) {
        window.seedAction({
          evt: 'click',
          bid: 'b_movie_9rec7wnu_mc',
          cid: 'c_c21utqjf',
          abtest: this.showNewPage ? 1 : 0,
          custom: {
            performance_id: this.performanceId
          }
        });
      }
      if (this.showNewPage && this.isDetail && !this.showMore) {
        this.$emit('gotoDetailTab');
      }
    },
    setHasMore: function setHasMore() {
      var _this = this;
      var originalShowMore = this.showMore;
      this.showMore = true;
      setTimeout(function () {
        _this.showMore = originalShowMore;
        var wrapper = _this.$refs.contentWrapper;
        if (!wrapper || !wrapper.offsetHeight) return;
        _this.hasMore = wrapper.offsetHeight > (_this.isDetail ? 1848 : 400);
      }, 1000);
    }
  }
};